import { Component } from '@angular/core';
import { REDCRSS_EVENTS } from '../../../shared/services/constants/redcross_evemts';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../../shared/services/toastr.service';
import { RedirectService } from '../../../shared/services/redirect.service';
import { DialogBaseComponent } from './dialog_base.component';
import { ENV } from '../../../environment';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../app_state';
import { take } from 'rxjs/operators';

@Component({
  selector: 'yi-integrate-send-to-developer-dialog',
  template: require('./send_to_developer.component.html'),
  styles: [require('./install_automatically_approval.component.scss'), require('./send_to_developer.component.scss')]
})
export class SendToDeveloperComponent extends DialogBaseComponent {

  private translate: TranslateService;
  private toastr: ToastService;
  private redirectService: RedirectService;
  private hasWidgetV3: boolean;
  constructor(redCrossService: AnalyticsTrackingProvider,
              translateService: TranslateService,
              toastr: ToastService,
              private store: Store<IAppState>,
              redirectService: RedirectService) {
    super('Send Installation Instructions', redCrossService);
    this.translate = translateService;
    this.toastr = toastr;
    this.redirectService = redirectService;
    this.store.select(state => state).pipe(take(1)).subscribe(
      items => {
        this.hasWidgetV3 = items.app.install.integrate.hasWidgetV3;
      });
  }

  sendEmail(form) {
    if (form.valid) {
      try {
        let properties = {
          ctaType: 'Button',
          ctaText: REDCRSS_EVENTS.SEND_TO_DEVELOPER,
          ctaName: REDCRSS_EVENTS.SEND_TO_DEVELOPER,
          developerEmail: form.controls.email.value,
          isWidgetV3Installation: this.hasWidgetV3,
          text: form.controls.instructionsText.value || this.translate.instant('DIALOGS.SEND_TO_DEVELOPER.TEXT')
        };
        this.redCross.track(REDCRSS_EVENTS.CTA_CLICK, properties);
        this.redCross.identifiedTrack(REDCRSS_EVENTS.BUTTON_CLICK, {
          product: REDCRSS_EVENTS.PRODUCT,
          btnContext: REDCRSS_EVENTS.REVIEWS_ACTIVATION,
          btnLocation: REDCRSS_EVENTS.INTEGRATE,
          btnName: REDCRSS_EVENTS.EMAIL_INSTRUCTIONS,
          btnText: REDCRSS_EVENTS.SEND_INSTRUCTIONS
        });
        this.close();
        this.toastr.success(this.translate.instant('DIALOGS.SEND_TO_DEVELOPER.SUCCESS'));
      } catch (ex) {
        this.toastr.error('install', 'sendEmail', this.translate.instant('DIALOGS.SEND_TO_DEVELOPER.FAILURE'), ex);
      }
    }
  }

  openAgencies() {
    this.redCross.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Button',
      ctaText: 'agency partner'
    });
    this.redirectService.redirectTo(ENV.YotpoAgencyPartner, true);
  }
}
